import { Capacitor } from '@capacitor/core';

/** Packaged EdgeFinances app running on iPhone/iPad (Capacitor iOS). */
export function isIosNativeApp(): boolean {
  return typeof window !== 'undefined' && Capacitor.getPlatform() === 'ios';
}

/** Any Capacitor native shell (Android or iOS). */
export function isNativeApp(): boolean {
  return typeof window !== 'undefined' && Capacitor.isNativePlatform();
}

/**
 * App Store build: sign-in only — no self-serve registration, Google SSO, or
 * in-app subscription / Razorpay checkout (Guideline 3.1.1). Workspace billing
 * is handled on the web; iOS users use accounts already activated there.
 */
export function isIosLoginOnlyApp(): boolean {
  return isIosNativeApp();
}

/** True when external payment checkout must not be shown (iOS App Store). */
export function isExternalBillingDisabled(): boolean {
  return isIosLoginOnlyApp();
}
